import React, { Children } from 'react';
export function PrivacyPolicy() {
  return <div className="py-12 bg-white" data-id="element-1176">
      <div className="container mx-auto px-4" data-id="element-1177">
        <div className="max-w-4xl mx-auto" data-id="element-1178">
          <div className="mb-8" data-id="element-1179">
            <h1 className="text-3xl font-bold text-slate-900 mb-2" data-id="element-1180">
              Privacy Policy
            </h1>
            <p className="text-sm text-slate-500" data-id="element-1181">Last Updated: January 2025</p>
          </div>
          <div className="prose prose-slate max-w-none" data-id="element-1182">
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1183">
              1. Introduction
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1184">
              This Privacy Policy describes how Nura Health ("we", "us", or
              "our") collects, uses, and protects your personal information when
              you use our medical tourism coordination services.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1185">
              2. Information We Collect
            </h2>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1186">
              2.1 Personal Information
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1187">
              We collect personal information that you provide directly to us,
              including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1188">
              <li data-id="element-1189">Name, email address, phone number, and mailing address</li>
              <li data-id="element-1190">Date of birth and gender</li>
              <li data-id="element-1191">Payment and billing information</li>
              <li data-id="element-1192">Communication preferences</li>
            </ul>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1193">
              2.2 Medical Information
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1194">
              With your consent, we collect health-related information necessary
              for coordinating your treatment, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1195">
              <li data-id="element-1196">Medical history and current health conditions</li>
              <li data-id="element-1197">Previous fertility treatments and outcomes</li>
              <li data-id="element-1198">Test results and medical records</li>
              <li data-id="element-1199">Treatment preferences and goals</li>
            </ul>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1200">
              2.3 Usage Information
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1201">
              We automatically collect certain information about your device and
              how you interact with our website, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1202">
              <li data-id="element-1203">IP address and browser type</li>
              <li data-id="element-1204">Pages visited and time spent on pages</li>
              <li data-id="element-1205">Referring website addresses</li>
              <li data-id="element-1206">Device information and operating system</li>
            </ul>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1207">
              3. How We Use Your Information
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1208">
              We use the information we collect for the following purposes:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1209">
              <li data-id="element-1210">
                To coordinate your fertility treatment with partner clinics
              </li>
              <li data-id="element-1211">To arrange travel and accommodation services</li>
              <li data-id="element-1212">To provide translation and interpretation support</li>
              <li data-id="element-1213">To communicate with you about your treatment journey</li>
              <li data-id="element-1214">To process payments and maintain financial records</li>
              <li data-id="element-1215">To improve our services and website functionality</li>
              <li data-id="element-1216">To comply with legal obligations and protect our rights</li>
            </ul>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1217">
              4. Information Sharing and Disclosure
            </h2>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1218">
              4.1 Partner Clinics
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1219">
              We share your medical information with partner fertility clinics
              solely for the purpose of coordinating your treatment. This
              sharing is done with your explicit consent and only with clinics
              directly involved in your care.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1220">
              4.2 Service Providers
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1221">
              We may share your information with third-party service providers
              who assist us in operating our business, including travel booking
              services, payment processors, and communication platforms. These
              providers are contractually obligated to protect your information.
            </p>
            <h3 className="text-lg font-semibold text-slate-900 mt-6 mb-3" data-id="element-1222">
              4.3 Legal Requirements
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1223">
              We may disclose your information if required by law or in response
              to valid legal requests by public authorities.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1224">
              5. Data Security
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1225">
              We implement appropriate technical and organizational measures to
              protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. These measures include:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1226">
              <li data-id="element-1227">Encryption of data in transit and at rest</li>
              <li data-id="element-1228">Regular security assessments and updates</li>
              <li data-id="element-1229">Access controls and authentication procedures</li>
              <li data-id="element-1230">Employee training on data protection</li>
            </ul>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1231">
              6. Your Rights
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1232">
              Under applicable data protection laws, you have the following
              rights:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4" data-id="element-1233">
              <li data-id="element-1234">
                Right to access: Request copies of your personal information
              </li>
              <li data-id="element-1235">
                Right to rectification: Request correction of inaccurate
                information
              </li>
              <li data-id="element-1236">
                Right to erasure: Request deletion of your personal information
              </li>
              <li data-id="element-1237">
                Right to restrict processing: Request limitation of how we use
                your data
              </li>
              <li data-id="element-1238">
                Right to data portability: Request transfer of your data to
                another service
              </li>
              <li data-id="element-1239">Right to object: Object to processing of your information</li>
              <li data-id="element-1240">
                Right to withdraw consent: Withdraw consent at any time where
                processing is based on consent
              </li>
            </ul>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1241">
              7. Data Retention
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1242">
              We retain your personal information for as long as necessary to
              fulfill the purposes outlined in this Privacy Policy, unless a
              longer retention period is required by law. Medical records are
              typically retained for 7 years in accordance with healthcare
              regulations.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1243">
              8. International Data Transfers
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1244">
              Your information may be transferred to and processed in countries
              other than your country of residence. We ensure appropriate
              safeguards are in place to protect your information in accordance
              with this Privacy Policy and applicable data protection laws.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1245">
              9. Children's Privacy
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1246">
              Our services are not directed to individuals under the age of 18.
              We do not knowingly collect personal information from children. If
              you become aware that a child has provided us with personal
              information, please contact us.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1247">
              10. Changes to This Privacy Policy
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1248">
              We may update this Privacy Policy from time to time. We will
              notify you of any material changes by posting the new Privacy
              Policy on this page and updating the "Last Updated" date.
            </p>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4" data-id="element-1249">
              11. Contact Us
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1250">
              If you have questions about this Privacy Policy or wish to
              exercise your rights, please contact us at:
            </p>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1251">
              Email: info@nurahealth.eu
              <br data-id="element-1252" />
              Address: [Company Address]
            </p>
          </div>
        </div>
      </div>
    </div>;
}